import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchLeaveSummaryData = createAsyncThunk("fetchLeaveSummaryData", async (obj) => {
  // const token = useSelector((state) => state.auth.token);

  const getLeaveSummary = CryptoJS.SHA256("/getLeaveSummary" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const id = CryptoJS.AES.encrypt(JSON.stringify(obj.id), SECRET_KEY).toString();
  const encodedId = encodeURIComponent(id); // ✅ very important

  const response = await fetch(`${env.backend_api_endpoint}/${getLeaveSummary}?id=${encodedId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: obj.token,
    },
  });

  const resData = await response.json();

  console.log(resData, "vgvvd")

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON

      console.log(resData.status, "bmsbdm")
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  // Return the full response (status, message, and decrypted data)
  return resData;
}
);

const LeaveSummarySlice = createSlice({
  name: "getLeaveSummary",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: async (builder) => {
    builder.addCase(fetchLeaveSummaryData.pending, (state, action) => {
      state.isLoading = true;
    });
    await builder.addCase(fetchLeaveSummaryData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchLeaveSummaryData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default LeaveSummarySlice.reducer;
